import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useSelector } from "react-redux";
import Truncate from "react-truncate";

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.common.white,
    wordWrap: "nowrap",
  },
}));

export default function UserName() {
  const classes = useStyles();
  const profile = useSelector((state) => state.user.profile);
  return (
    <div>
      <Truncate width={200} lines={1} className={classes.text} variant="body1">
        {profile.firstname} {profile.lastName}
      </Truncate>
    </div>
  );
}
